import { getErrorResponse, getHttpStatus, getQcsErrorCode, isHttpServerError } from '../../utils/core/httpErrors';
import { getPostponableActionAttemptsLeft, type PostponableAction } from './postponedActionsTypes';

const postponeStatuses4XX = new Set([
  401, // Unauthorized
  407, // Proxy Authentication Required
  408, // Request Timeout
  410, // Gone
  418, // I'm a teapot
  421, // Misdirected Request
  423, // Locked (WebDAV)
  424, // Failed Dependency (WebDAV)
  429, // Too Many Requests
  451, // Unavailable For Legal Reasons
]);

const isObject = (value: unknown): value is Record<string, unknown> => typeof value === 'object' && value !== null;

export function shouldPostponeAction(action: PostponableAction, error: unknown): boolean | number {
  // Item errors are a 200 response carrying per-item rejections, thrown as a bare array by
  // transformResourcesWithResponse. They have no `error.response`, so without this they fall into
  // the transient branch below and get queued for retry — but replaying the action re-sends the
  // same items to the same rejection, and the caller's promise never settles in the meantime.
  if (Array.isArray(error)) {
    return false;
  }

  const hasResponse = isObject(getErrorResponse(error));
  const status = getHttpStatus(error);

  if (status === 401 && getQcsErrorCode(error) === 'QCS-0401-19') {
    return false;
  }

  if (!hasResponse || (status !== undefined && postponeStatuses4XX.has(status)) || isHttpServerError(error)) {
    const attemptsLeft = getPostponableActionAttemptsLeft(action);
    return !action.meta || attemptsLeft === undefined || attemptsLeft;
  }

  return false;
}
